export default __webpack_public_path__ + "static/media/call1.2d028b3c.svg";